/* ROMP — Shopify theme interactions: buy box, gallery, AJAX cart, faq */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var FREE_SHIP = { USD: 60, CAD: 80, GBP: 50, AUD: 95, NZD: 99 };
  var overlay = $('#overlay'), cartEl = $('#cart');

  function fmt(cents, currency) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  // ---- buy box: supply tiers + subscribe/one-time mode ----
  var addBtn = $('#addToCart');
  var modeToggle = $('#modeToggle');
  var selected = {
    variant: addBtn ? addBtn.getAttribute('data-variant') : null,
    mode: modeToggle ? 'sub' : 'once',
    plan: null
  };

  function activeTier() { return $('#tiers .tier.active'); }

  var CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';

  function refreshBuyBox() {
    var t = activeTier();
    if (!t) return;
    var isSub = selected.mode === 'sub';
    selected.variant = t.getAttribute('data-variant');
    selected.plan = isSub ? t.getAttribute('data-plan') : null;   // only real plans get sent to cart
    if (addBtn) addBtn.setAttribute('data-variant', selected.variant);

    // per-day price + strike on every tier row
    var cpd = parseFloat((($('#weightRow .weight-opt.active') || {}).getAttribute && $('#weightRow .weight-opt.active').getAttribute('data-cpd')) || 1) || 1;
    $$('#tiers .tier').forEach(function (row) {
      var day = row.querySelector('.day'), was = row.querySelector('.was');
      // echte duur voor DIT gewicht
      var chews = parseFloat(row.getAttribute('data-chews') || 0);
      var realDays = chews > 0 ? Math.floor(chews / cpd) : 0;
      var dEl = row.querySelector('.t-days');
      if (dEl && realDays) dEl.textContent = realDays + ' days';
      // per-dag op basis van echte duur
      var sc = parseFloat(row.getAttribute('data-sub-cents') || 0), oc = parseFloat(row.getAttribute('data-once-cents') || 0);
      if (realDays > 0) {
        if (day) day.textContent = fmt((isSub ? sc : oc) / realDays, CURRENCY);
        if (was) was.textContent = fmt((isSub ? oc : parseFloat(row.getAttribute('data-cmpb-cents') || oc)) / realDays, CURRENCY);
      }
      if (was) {
        // tekst is hierboven al herrekend op de ECHTE duur; hier alleen tonen/verbergen
        if (isSub) { was.style.display = ''; }
        else {
          var rc = parseFloat(row.getAttribute('data-cmpb-cents') || 0), ro = parseFloat(row.getAttribute('data-once-cents') || 0);
          was.style.display = (rc > ro) ? '' : 'none';
        }
      }
    });

    // totals + strike + savings chip
    var total = isSub ? t.getAttribute('data-sub-total') : t.getAttribute('data-once-total');
    if ($('#totalPrice')) $('#totalPrice').textContent = total;
    if ($('#btnPrice')) $('#btnPrice').textContent = total;
    if ($('#stickyPrice')) $('#stickyPrice').textContent = total;

    var once = parseFloat(t.getAttribute('data-once-cents')), sub = parseFloat(t.getAttribute('data-sub-cents'));
    var cmpb = parseFloat(t.getAttribute('data-cmpb-cents') || 0);
    var strike = $('#totalStrike'), chip = $('#saveChip'), chipTxt = $('#saveChipTxt');
    if (isSub && once > sub) {
      if (strike) { strike.textContent = t.getAttribute('data-once-total'); strike.style.display = ''; }
      if (chip && chipTxt) {
        chipTxt.textContent = 'You save ' + fmt(once - sub, CURRENCY) + ' (' + Math.round((once - sub) / once * 100) + '%)';
        chip.style.display = 'inline-flex';
      }
    } else if (!isSub && cmpb > once) {
      if (strike) { strike.textContent = t.getAttribute('data-cmpb-total'); strike.style.display = ''; }
      if (chip && chipTxt) {
        chipTxt.textContent = 'Multi-jar deal: you save ' + fmt(cmpb - once, CURRENCY) + ' (' + Math.round((cmpb - once) / cmpb * 100) + '%)';
        chip.style.display = 'inline-flex';
      }
    } else {
      if (strike) strike.style.display = 'none';
      if (chip) chip.style.display = 'none';
    }

    if ($('#subUsps')) $('#subUsps').style.display = isSub ? 'grid' : 'none';

    var tag = $('#subSaveTag');
    if (tag && once > 0 && sub > 0 && once > sub) tag.textContent = Math.round((once - sub) / once * 100) + '%';
  }

  // ---- shipping info modal ----
  var shipModal = $('#shipModal');
  if ($('#shipInfoBtn') && shipModal) {
    $('#shipInfoBtn').addEventListener('click', function () { shipModal.classList.add('open'); });
    $('#shipModalClose').addEventListener('click', function () { shipModal.classList.remove('open'); });
    shipModal.addEventListener('click', function (e) { if (e.target === shipModal) shipModal.classList.remove('open'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shipModal.classList.remove('open'); });
  }

  $$('#tiers .tier').forEach(function (tier) {
    tier.addEventListener('click', function () {
      $$('#tiers .tier').forEach(function (t) { t.classList.remove('active'); });
      tier.classList.add('active');
      refreshBuyBox();
    });
  });

  if (modeToggle) {
    $$('#modeToggle button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('#modeToggle button').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        selected.mode = btn.getAttribute('data-mode');
        refreshBuyBox();
      });
    });
  }
  refreshBuyBox();

  // ---- weight selector (dosing text only) ----
  $$('#weightRow .weight-opt').forEach(function (btn) {
    btn.addEventListener('click', function () {
      $$('#weightRow .weight-opt').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      if ($('#doseHint')) $('#doseHint').textContent = btn.getAttribute('data-dose');
      refreshBuyBox();
    });
  });

  // ---- buy box gallery ----
  var bbMainImg = $('#bbMainImg');
  if (bbMainImg) {
    $$('#bbThumbs .bb-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        $$('#bbThumbs .bb-thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        bbMainImg.src = thumb.getAttribute('data-src');
        bbMainImg.classList.toggle('contain', thumb.hasAttribute('data-contain'));
      });
    });
  }

  // ---- gallery swipe (dots) ----
  var bbMainBox = $('#bbMain');
  if (bbMainBox) {
    var swx = null;
    bbMainBox.addEventListener('touchstart', function (e) { swx = e.touches[0].clientX; }, { passive: true });
    bbMainBox.addEventListener('touchend', function (e) {
      if (swx === null) return;
      var dx = e.changedTouches[0].clientX - swx; swx = null;
      if (Math.abs(dx) < 40) return;
      var thumbs = $$('#bbThumbs .bb-thumb');
      if (!thumbs.length) return;
      var idx = -1;
      thumbs.forEach(function (t, i) { if (t.classList.contains('active')) idx = i; });
      var next = dx < 0 ? Math.min(thumbs.length - 1, idx + 1) : Math.max(0, idx - 1);
      if (next !== idx && idx > -1) thumbs[next].click();
    }, { passive: true });
  }

  // ---- AJAX cart ----
  function openCart() { if (overlay) overlay.classList.add('show'); if (cartEl) cartEl.classList.add('show'); document.body.style.overflow = 'hidden'; }
  function closeCart() { if (overlay) overlay.classList.remove('show'); if (cartEl) cartEl.classList.remove('show'); document.body.style.overflow = ''; }

  function renderCart(cart) {
    var count = cart.item_count;
    if ($('#cartCount')) $('#cartCount').textContent = count;
    var body = $('#cartBody'), foot = $('#cartFoot');
    if (!body) return;
    if (!count) {
      body.innerHTML = '<div class="cart-empty"><svg viewBox="0 0 24 24"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.5 12h11l2-8H6"/></svg><p>Your cart is empty.</p></div>';
      if (foot) foot.style.display = 'none';
      updateShipBar(0, cart.currency);
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      return '<div class="cart-line" data-key="' + it.key + '">' +
        '<div class="thumb">' + (it.image ? '<img src="' + it.image + '" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:10px">' : 'R') + '</div>' +
        '<div><div class="cl-name">' + it.product_title + '</div>' +
        '<div class="cl-opt">' + (it.variant_title || '') + '</div>' +
        '<div class="qty"><button data-dec="' + it.key + '">−</button><span>' + it.quantity + '</span><button data-inc="' + it.key + '">+</button></div></div>' +
        '<div><div class="cl-price">' + fmt(it.final_line_price, cart.currency) + '</div>' +
        '<a class="cl-remove" data-rm="' + it.key + '">Remove</a></div></div>';
    }).join('');
    if ($('#cartSubtotal')) $('#cartSubtotal').textContent = fmt(cart.items_subtotal_price, cart.currency);
    // savings vs one-time/compare-at pricing
    var savings = 0;
    cart.items.forEach(function (it) {
      var cmp = (window.ROMP_CMP || {})[it.variant_id];
      if (cmp && cmp.c > 0) savings += Math.max(0, cmp.c * it.quantity - it.final_line_price);
    });
    var savRow = $('#cartSavingsRow');
    if (savRow) {
      if (savings > 0) { savRow.style.display = 'flex'; $('#cartSavings').textContent = '–' + fmt(savings, cart.currency); }
      else savRow.style.display = 'none';
    }
    if ($('#cartTotal')) $('#cartTotal').textContent = fmt(cart.total_price, cart.currency);
    if (foot) foot.style.display = 'block';
    updateShipBar(cart.total_price, cart.currency);
    $$('#cartBody [data-inc]').forEach(function (b) { b.onclick = function () { changeQty(b.getAttribute('data-inc'), +1); }; });
    $$('#cartBody [data-dec]').forEach(function (b) { b.onclick = function () { changeQty(b.getAttribute('data-dec'), -1); }; });
    $$('#cartBody [data-rm]').forEach(function (b) { b.onclick = function () { changeQtyTo(b.getAttribute('data-rm'), 0); }; });
  }

  function updateShipBar(total, currency) {
    var thr = (FREE_SHIP[currency] || 60) * 100;
    var msg = $('#shipMsg'), fill = $('#shipFill');
    if (!msg) return;
    if (total >= thr) { msg.innerHTML = '<b>Free shipping unlocked</b> — happier hips are on the way.'; if (fill) fill.style.width = '100%'; }
    else { msg.innerHTML = fmt(thr - total, currency) + " more and your pup's box <b>ships free</b>"; if (fill) fill.style.width = Math.min(100, (total / thr) * 100) + '%'; }
  }

  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function changeQty(key, delta) {
    var span = $('#cartBody [data-key="' + key + '"] .qty span');
    var q = span ? parseInt(span.textContent, 10) + delta : delta;
    changeQtyTo(key, Math.max(0, q));
  }
  function changeQtyTo(key, q) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart() {
    if (!selected.variant) return;
    addBtn && addBtn.setAttribute('disabled', 'true');
    var item = { id: Number(selected.variant), quantity: 1 };
    if (selected.plan) item.selling_plan = Number(selected.plan);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { return r.json(); })
      .then(function () { return getCart(); })
      .then(function (cart) { renderCart(cart); openCart(); })
      .catch(function () { window.location = '/cart'; })
      .finally(function () { addBtn && addBtn.removeAttribute('disabled'); });
  }

  if (addBtn) addBtn.addEventListener('click', addToCart);
  if ($('#stickyAdd')) $('#stickyAdd').addEventListener('click', addToCart);
  if ($('#cartOpen')) $('#cartOpen').addEventListener('click', function (e) { e.preventDefault(); getCart().then(renderCart); openCart(); });
  if ($('#cartClose')) $('#cartClose').addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  // ---- faq ----
  $$('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q'), a = item.querySelector('.faq-a');
    q.addEventListener('click', function () {
      var open = item.classList.contains('open');
      $$('.faq-item').forEach(function (o) { o.classList.remove('open'); o.querySelector('.faq-a').style.maxHeight = null; });
      if (!open) { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });

  // ---- mobile nav ----
  var mob = $('#mobileNav');
  if ($('#hamburger')) $('#hamburger').addEventListener('click', function () { mob.classList.add('show'); });
  if ($('#mobileClose')) $('#mobileClose').addEventListener('click', function () { mob.classList.remove('show'); });
  if (mob) $$('a', mob).forEach(function (a) { a.addEventListener('click', function () { mob.classList.remove('show'); }); });

  // ---- sticky ATC: altijd zichtbaar op mobiel (CSS) ----

  // ---- count-up ----
  var counters = $$('[data-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, target = +el.getAttribute('data-count'), start = null;
        function step(ts) { if (!start) start = ts; var p = Math.min((ts - start) / 1400, 1); el.textContent = Math.floor(p * target); if (p < 1) requestAnimationFrame(step); else el.textContent = target; }
        requestAnimationFrame(step); co.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(function (c) { co.observe(c); });
  }

  // ---- mobile carousels: scroll-snap + dot indicators ----
  function buildDots(car) {
    var next = car.nextElementSibling;
    if (next && next.classList.contains('carousel-dots')) next.remove();
    var kids = Array.prototype.filter.call(car.children, function (c) { return getComputedStyle(c).display !== 'none'; });
    if (kids.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'carousel-dots';
    kids.forEach(function (kid, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      if (i === 0) b.classList.add('active');
      b.addEventListener('click', function () {
        car.scrollTo({ left: kid.offsetLeft - car.offsetLeft - 18, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });
    car.parentNode.insertBefore(dots, car.nextSibling);
    var ticking = false;
    car.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var mid = car.scrollLeft + car.clientWidth / 2, best = 0, bestD = 1e9;
        kids.forEach(function (kid, i) {
          var c = kid.offsetLeft - car.offsetLeft + kid.offsetWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bestD) { bestD = d; best = i; }
        });
        Array.prototype.forEach.call(dots.children, function (b, i) { b.classList.toggle('active', i === best); });
      });
    }, { passive: true });
  }
  function initCarousels() { $$('.m-carousel').forEach(buildDots); }
  if (window.matchMedia('(max-width: 900px)').matches) initCarousels();

  // ---- reviews show-more ----
  var revMore = $('#revMore');
  if (revMore) {
    revMore.addEventListener('click', function () {
      var grid = document.querySelector('.rev-grid');
      if (grid) grid.classList.add('expanded');
      revMore.parentNode.style.display = 'none';
      if (window.matchMedia('(max-width: 900px)').matches && grid) buildDots(grid);
    });
  }

  // ---- lead magnet ----
  var lmForm = $('#lmForm');
  if (lmForm) {
    lmForm.addEventListener('submit', function (e) {
      e.preventDefault();
      lmForm.style.display = 'none';
      if ($('#lmNote')) $('#lmNote').style.display = 'none';
      if ($('#lmDone')) $('#lmDone').style.display = 'block';
    });
  }

  // ---- dispatch-cutoff countdown (honest rolling 4pm cutoff) ----
  var cd = $('#dispatchCountdown'), cdLabel = $('#dispatchLabel');
  if (cd) {
    var tick = function () {
      var now = new Date();
      var cutoff = new Date(now); cutoff.setHours(16, 0, 0, 0);
      var today = now < cutoff;
      if (!today) { cutoff.setDate(cutoff.getDate() + 1); }
      var day = cutoff.getDay();
      var label = today ? 'today' : (day === 6 || day === 0 ? 'Monday' : 'tomorrow');
      var diff = cutoff - now, h = Math.floor(diff / 3.6e6), m = Math.floor((diff % 3.6e6) / 6e4), s = Math.floor((diff % 6e4) / 1e3);
      cd.textContent = h + 'h ' + (m < 10 ? '0' : '') + m + 'm ' + (s < 10 ? '0' : '') + s + 's';
      if (cdLabel) cdLabel.textContent = label;
    };
    tick(); setInterval(tick, 1000);
  }

  // init cart count
  getCart().then(function (c) { if ($('#cartCount')) $('#cartCount').textContent = c.item_count; }).catch(function () {});
})();
